import { FunctionComponent } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { useStore } from "../store";
import NotFound from "../pages/NotFound";

export default function createAuthComponent<T>(
  Component: FunctionComponent<T>,
  admin = false
) {
  return function RequireAuth(props: T) {
    let store = useStore();
    let location = useLocation();
    if (!store.userInfo) {
      // Redirect them to the /login page, but save the current location they were
      // trying to go to when they were redirected. This allows us to send them
      // along to that page after they login, which is a nicer user experience
      // than dropping them off on the home page.
      return <Navigate to="/login" state={{ from: location }} />;
    }

    if (admin && !store.isAdmin) {
      return <NotFound />;
    }

    return <Component {...props} />;
  };
}
